<template>
  <div :class="['widget', {'border-error': error}]">

    <div style="padding: 24px 24px 0 24px">
      <v-layout>
        <span class="subheading">
          Noise
        </span>
      </v-layout>
      <template v-if="loading">
        <v-layout
          justify-center
          fill-height>
          <v-progress-circular
            size="50"
            indeterminate/>
        </v-layout>
      </template>

      <template v-else>
        <div style="padding: 24px 24px 0 24px">
          <line-chart
            :library="style"
            :data="noise"/>
        </div>
      </template>
    </div>

  </div>
</template>

<script>
export default {
  name: "noise",
  data () {
    return {
      error: false,
      loading: true,
      noise: [],
      style: {
        elements: {
          line: { tension: 0.5 },
          point: {
            hitRadius: 2,
            radius: 0
          }
        },
        scales: {
          xAxes: [
            {
              display: true,
              ticks: { fontColor: "white" },
              gridLines: {
                display: false,
                color: "white"
              },
              scaleLabel: {
                display: true,
                labelString: "Mean spec (dBm)"
              }
            }
          ],
          yAxes: [
            {
              display: true,
              ticks: {
                fontColor: "white",
                callback (value) {
                  return `${value} dBm`;
                }
              },
              gridLines: {
                display: false,
                color: "white"
              }
            }
          ]
        },
        tooltips: {
          intersect: false,
          mode: "index"
        }
      }
    };
  },
  computed: {
    data () {
      return this.noise;
    }
  },
  created () {
    this.loading = true;
    this.$http.
      get(`/api/sites/${this.$route.params.id}/noise`).
      then((r) => this.noise = Array.from(r.data)).
      catch(() => this.error = true).
      finally(() => this.loading = false);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Site/NoiseStats.vue